<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <h3> Onboarding Status </h3>
                        </div>
                        <div class="col-sm-6 d-flex justify-content-end" style="display: flex; justify-content: flex-end; align-items: center;">
                            <!-- Can remove commented code after Suraj's Confirmation -->
                            <!-- <div class="edit" *ngIf="userCreationStatus === 'withItTeam' || userCreationStatus === 'waitingForApproval'"> -->
                            <div class="edit" *ngIf="userCreationStatus === 'withItTeam'">   <!-- Need to comment code after Suraj's Confirmation -->
                                <button type="button" title="Edit" (click)="updateOnboardingForm()">
                                    <span><i class="ri-pencil-line"></i> </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <ag-grid-angular
                        style="height: 620px;"
                        class="ag-theme-material"
                        (gridReady)="onGridReady($event)"
                        [rowData]="rowData"
                        [columnDefs]="columnDefs"
                        pagination="true"
                        [defaultColDef]="defaultColDef"
                        [suppressRowClickSelection]="true"
                        [rowSelection]="rowSelection"
                        (selectionChanged)="onSelectionChanged($event)"
                        paginationPageSize="10"
                    >
                  </ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>

<!-- Delete an item -->
<div class="modal fade" id="deleteLeaveModal" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure want to delete?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>{{deleteConfirmationMsg}}?</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalDeleteLeave" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0" (click)="deleteleaveAppRates()">Yes Delete</button>
                </div>
            </form>
        </div>
    </div>
</div>
